import type { ReturnHelpLinkModel } from '../../../api/types/ReturnCardModel';

/**
* Related help links for the simple returns card.
*
* Taken from the "Limited data" section of the article list content provided —
* that section is the one that applies here, since this version has no
* lifecycle status to vary the links by. The per-status lists in that same
* document belong to the robust version.
*
* Paths are relative on purpose. The articles live on the same host the Help
* Center runs on, so leaving off the domain lets each environment resolve to
* itself instead of sending Try traffic to production.
*/
export const RETURN_HELP_LINKS: ReturnHelpLinkModel[] = [
  {
    id: 'proof-of-purchase',
    label: 'Proof of purchase needed?',
    url: '/help?a=What-proof-of-purchase-do-I-need-to-return-an-item?---id--_rARwA-PRyakdT5rgWk6rA',
  },
  {
    id: 'original-packaging',
    label: 'Original packaging required?',
    url: '/help?a=Do-I-need-to-return-using-the-original-packaging?---id--bmdAPhauT-GdOk_1lxhR5g',
  },
  {
    id: 'split-by-tender',
    label: 'How refunds are split by tender',
    url: '/help/categories?a=Can-you-tell-me-how-my-refund-amount-will-be-distributed-by-tender-used---id--y1wQA3KARbi5-MfkGtJThQ&hc=returnsexchanges&secHc=howToReturn',
  },
];

export default RETURN_HELP_LINKS;
